module.exports = __webpack_public_path__ + "bf38205914943a65f3580bb47a8b73c7.svg";